<template>
  <div class="material split-screen" :style="{minHeight: `${$store.getters.fullHeight}px`}" :class="{'extended' : heated === false}">
    <div class="color-half">
      <div class="container">
        <p class="page-title">Apply Your Knowledge</p>

        <div class="content">
          <h2 class="material-name">{{ material.text }}</h2>
          
          <div class="dot-circle">
            <Dots :fill="material.fill" :w="400" :h="400" :r="20" :wiggle="wiggle"/>
          </div>

          <div class="stats">
            <div class="stat">
              <p>Mass</p>
              <p>{{ material.mass }}.g</p>
            </div>
            <div class="stat">
              <p>Start Temp</p>
              <p>{{ material.startTemp }}.0&deg;C</p>
            </div>
            <div class="stat">
              <p>Energy</p>
              <p>{{ material.energy }}.J</p>
            </div>
            <div class="stat">
              <p>End Temp</p>
              <p v-if="heated">{{ material.endTemp }}&deg;C</p>
              <button class="btn heat-btn orange" @click="heated = true; wiggle=material.wiggle" v-if="!heated"><span class="text">Heat Up</span> <img class="lil-flame" src="../assets/flame-solid.svg" alt=""></button>
            </div>
          </div>
          
        </div>
      </div>
    </div>

    
    <div class="bigger-half">
      <div class="container">
        <form @submit.prevent="checkAnswer" class="material-form">

          <h2 class="instructions"><strong>Calculate the specific heat capacity.</strong></h2>

          <label for="answer" class="material-answer" v-if="strike < 3" :class="{'focused': focused === true, 'wrong' : gotWrong}">
            <input id="answer" name="answer" type="text" v-model="answer" @click="hintHider(false)" @focus="focused = true" @blur="focused = false" ref="answer" >
            <span class="label" v-if="answer.length">J/g&deg;C</span>
          </label>

          <div class="hint" v-show="gotWrong === true" :style="{height: `${hintHeight}`}">
            <div class="inner-hint" ref="innerhint">
              <p v-if="strike <= 2"><strong>HINT</strong></p>
              <p v-if="strike <= 2">For Reference:</p>
              <img src="../assets/firsthint.jpg" v-if="strike === 1" alt="hint">
              <img :src="getImg()" v-if="strike === 2" alt="hint">
              <p class="the-answer" v-if="strike >= 3">The Answer is <strong>{{ material.heatCapacity }}J/g°C</strong></p>
            </div>
          </div>

          <input type="submit" value="Submit" :disabled="!answer || gotWrong" class="btn sub-btn" v-if="strike < 3">
          <button class="btn" @click="moveOn()" v-if="strike >= 3" >Continue &nbsp;&rarr;</button>

          <p class="note">Note: Pay attention to significant figures when entering your answer!</p>
        </form>
      </div>

      <transition name="fade">
        <button class="hint-btn" v-if="heated" @click="showModal=true">
          <span class="little">Specific Heat Equation</span>
          <span class="big">Q = mcΔT</span>
          <span class="mark">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" aria-labelledby="title"
              aria-describedby="desc" role="img" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Question Help</title>
                <desc>A line styled icon from Orion Icon Library.</desc>
                <circle data-name="layer2"
                cx="32" cy="32" r="30" fill="none" stroke="#4F4F4F" stroke-miterlimit="10"
                stroke-width="3" stroke-linejoin="round" stroke-linecap="round"></circle>
                <path data-name="layer1" d="M24 24.528C24 21.647 26.206 17 32.47 17S40 22.628 40 24.528s-.59 4.092-4.057 7.558C32.477 35.552 32 37.353 32 39v2"
                fill="none" stroke="#4F4F4F" stroke-miterlimit="10" stroke-width="3" stroke-linejoin="round"
                stroke-linecap="round"></path>
                <circle data-name="layer1" cx="32" cy="47" r="2" fill="none" stroke="#4F4F4F"
                stroke-miterlimit="10" stroke-width="3" stroke-linejoin="round" stroke-linecap="round"></circle>
              </svg>
          </span>
        </button>
      </transition>

    <Modal :show="showModal" @close="showModal = false" :title="material.name">
      <div class="modal-hint">
        <h1>{{ material.equation }}</h1>
        <div class="row" v-for="step of material.steps" :key="step.text">
          <p class="letter">{{ step.variable }}</p>
          <p class="text" v-html="step.text"></p>
        </div>
      </div>
    </Modal>
    </div>
      
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import Dots from '../components/Dots'
import Modal from '../components/Modal'

export default {
  
  components: {
    Dots,
    Modal
  },
  data() {
    return {
      heated: false,
      gotWrong: false,
      hintHeight: '0px',
      material: Object,
      answer: '',
      showModal: false,
      wiggle: 0.7,
      focused: false,
      strike: 0,
    }
  },
  methods: {
    checkAnswer(){
      if(this.answer === 'yay' || `${this.answer}` === `${this.material.heatCapacity}`) {
        this.hintHider(false);
        this.$store.dispatch('doneMaterial', this.material.id)
        this.$router.push('/quiz/materials')
      }else{
        this.strike = this.strike+1
        this.hintHider(true)
        this.$refs.answer.blur();
      }
    },
    hintHider(bool){
      if(bool === true){
        this.gotWrong = true;
        setTimeout(() => {
        this.hintHeight = `${this.$refs.innerhint.clientHeight}px`
        }, 10);

        setTimeout(() => {
          this.hintHeight = 'auto'
        }, 600);
      }else{
        this.hintHeight = `${this.$refs.innerhint.clientHeight}px`
        setTimeout(() => {
          this.hintHeight = '0px'
        }, 10);
        setTimeout(() => {
          this.gotWrong = false;
        }, 600);
      }
    },
    getImg(){
      if(!this.material.hintImg) return;
      return require(`../assets/${this.material.hintImg}`)
    },
    moveOn(){
      this.$store.dispatch('doneMaterial', this.material.id)
      this.$router.push('/quiz/materials')
    }
  },
  computed: {
    ...mapGetters(['getMaterial'])
  },
  mounted() {
    let id = parseInt(this.$route.params.id);
    this.material = this.getMaterial(id)

  },
  watch: {
  },
}
</script>


<style lang="scss">
  .split-screen{
    transition: all 500ms;
    &.extended{
      .color-half{
        flex: 1 1 100%; 
        border-radius: 0;
        justify-content: center;
      }
      .bigger-half{flex: 0 0 0%; padding: 0;}
    }
  }

  .color-half{
    transition: all 500ms;
  }
  .bigger-half{
    transition: all 500ms;
    .container{
      max-width: 60rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  }

  h2.material-name{
    text-align: center;
    font-size: 2.5rem;
    margin-top: 0rem;
  }

  .dot-circle{
    overflow: hidden;
    border-radius: 15rem;
    height: 18.5rem;
    width: 18.5rem;
    margin: 1rem auto;
    position: relative;

    .dot-container{
      position: absolute;
      top: -2rem;
      left: -2rem;
      svg { max-width: none; }
    }
  }

  .stats{
    width: 100%;
    max-width: 44rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0 1rem;
    margin-top: 2rem;

    .stat{
      font-size: 1.1rem;
      display: flex;
      align-items: center;
      
      &:last-of-type, &:nth-of-type(3){
        padding-top: 1rem;
      }

      &:nth-of-type(odd){
        border-right: 1px solid #fff;
      }

      p{
        flex: 1 1 50%;
        text-align: center;
        margin: 0;
      }
    }
  }

  .hint-btn{
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-template-areas: 'little mark' 'big mark';
    background: none;
    border: none;
    color: $grey;
    text-align: left;
    grid-gap: 0 0.5rem;
    position: absolute;
    bottom: 0.5rem;
    right: 0.5rem;
    cursor: pointer;

    .little{
      font-size: 1rem;
      grid-area: little;
    }

    .big{
      font-size: 2rem;
      grid-area: big;
      font-weight: bold;
    }

    .mark{
      grid-area: mark;
      max-width: 3rem;
    }
  }

  .hint{
    overflow: hidden;
    transition: height 500ms;
    width: 35rem;
    text-align: left;

    .the-answer{
      font-size: 2rem;

      strong{
        color: $green;
      }
    }
  }

  .instructions{
    text-align: left;
  }

  .note{
    margin-top: 4rem;
    font-size: 1.3rem;
    width: 35rem;
    text-align: left;
    color: $grey;
  }

  .material-form{
    text-align: left;
  }

  .material-answer{
    font-size: 2.1rem;
    padding: 1rem;
    width: 35rem;
    border: solid 2px $light;
    outline: none;
    color: $grey;
    display: block;
    text-align: left;
    cursor: text;

    input{
      font-size: 2.1rem;
      padding: 0;
      margin: 0;
      border: none;
      font-family: $font;
      outline: none;
      color: $grey;
      width: 3.6rem;
    }

    &.focused{
      border-color: $green;
    }

    &.wrong{
      border-color: $red;
    }
  }

  .sub-btn{
    text-align: center;
    margin-top: 2rem;
    display: block;
    cursor: pointer;
  }

  .modal-hint{
    color: #ffffff;
    max-width: 45rem;
    margin: 0 auto;


    h1{
      font-size: 4rem;
    }

    .row{
      display: flex;
      text-align: left;
      font-size: 1.3rem;

      .letter{
        flex: 0 0 auto;
        padding-right: 3rem;
        font-weight: bold;
        font-size: 1.6rem;
      }

      .text{
        flex: 1 1 auto;
      }
    }
  }
</style>